"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillInConfigDefaults = void 0;
const types_1 = require("../../types");
const utils_1 = require("../../lib/utils");
const v8_1 = require("./v8");
function fillInConfigDefaults({ serverConfig, useV8 = false, useLegacyConfig = false, pmcUrl = '' }) {
    let config;
    // if we're using the old configs from CS, transpose them to the new shape the widget expects.
    if (useLegacyConfig) {
        config = (0, v8_1.transposeConfig)((0, utils_1.buildConfigFromPartialConfigV8)(serverConfig));
    }
    else {
        config = (0, utils_1.buildConfigFromPartialConfig)(serverConfig);
    }
    // if we're using search v9, transpose the typeahead categories to the new v9 categories, but only if using legacy config (from CS),
    // configs coming from the admin API will already have the correct (v9) categories
    if (!useV8 && useLegacyConfig) {
        const { typeahead_categories: v8TypeaheadCategories } = config.params;
        const v8DisplayDict = serverConfig.display_dictionary;
        config.params.typeahead_categories = (0, v8_1.mapv8TypeaheadCategoriesToV9)(v8TypeaheadCategories, v8DisplayDict);
    }
    return Object.assign(Object.assign({}, config), { index: (0, utils_1.deriveIndex)(config, pmcUrl), 
        // KENG-30502 cateogry map used to quickly validate/filter categories from typeahead responses
        // could potentially go away when we migrate to v9
        validTypeaheadCategories: (0, utils_1.buildValidTypeaheadCategories)(config), template: (0, utils_1.formatTemplateWithTheme)((0, types_1.templateFromKey)(config.params.template_name), config.theme) });
}
exports.fillInConfigDefaults = fillInConfigDefaults;
//# sourceMappingURL=fillInConfigDefaults.js.map